import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ComunidadPublicacionService, ComunidadService, MenuFuncionService } from '../../../../src/app/shared/services';
import { Comunidad, ComunidadPublicacion, MenuFuncionCodes } from '../../../../src/app/shared/model';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-comunidadPublicacionView',
    templateUrl: './comunidadPublicacionView.component.html',
    styleUrls: ['./comunidadPublicacionView.component.scss']
})

export class ComunidadPublicacionViewComponent implements OnInit{

    canView: boolean;
    isValidating: boolean;
    msgError: string;
    isSearching: boolean;
    isComunidadSearching: boolean;
    isAttachmentSearching: boolean;

    item: ComunidadPublicacion;
    comunidad: Comunidad;
    tituloHtml: any;
    descripcionHtml: any;

    constructor(
        private route:ActivatedRoute,
        private location: Location,
        private comunidadPublicacionService: ComunidadPublicacionService,
        private comunidadService: ComunidadService,
        private menuService: MenuFuncionService,
        private sharedFunctions: SharedFunctions,
        private sanitizer: DomSanitizer
    ){}

    ngOnInit(): void {
        this.isValidating = true;
        this.menuService.checkMenuPadre(MenuFuncionCodes.DASHBOARDS).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.isValidating = false;
                this.canView = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PUBLICACIONES);
                this.loadView();
            }else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
              }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView(){
        this.loadEntity();
    }

    loadEntity(){
        this.route.params.subscribe(params =>{
            if (params['id'] != null && params['id'] != '0'){
                var id = Number(params['id']);
                if(id > 0){
                    if(this.canView){
                        this.isSearching = true;
                        this.comunidadPublicacionService.get(id).subscribe(data => {
                            this.isSearching = false;
                            if (data != null && data.Success){
                                this.item = data.Result;
                                this.tituloHtml = this.sanitizer.bypassSecurityTrustHtml(this.item.Titulo ?? '');
                                this.descripcionHtml = this.sanitizer.bypassSecurityTrustHtml(this.item.Descripcion ?? '');

                                if(this.item != null && this.item.ComunidadId > 0 && this.item.Id > 0){
                                    this.getComunidad(data.Result.ComunidadId);
                                    this.loadAttachments(this.item.Id);
                                }

                            }
                            else
                                this.msgError = "Ocurrió un error al intentar obtener los datos de la Publicación.";
                        },(err: HttpErrorResponse) => {
                            this.isSearching = false;
                            this.sharedFunctions.handleError(err, true);
                        })
                    }else{
                        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                        this.onCancel();
                    }
                }
                else
                    this.msgError = "Item no válido.";
            }
        });
    }

    loadAttachments(id: number) {
        this.isAttachmentSearching = true;
        this.comunidadPublicacionService.getAttachments(id).subscribe(data => {
            this.isAttachmentSearching = false;
            if (data != null && data.Success)
                this.item.Adjuntos = data.Result?.filter(f => !f.IncluidoEnCuerpoMensaje);

            if (this.item.Adjuntos == null)
                this.item.Adjuntos = []

        },
        (err: HttpErrorResponse) => {
            this.isAttachmentSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getComunidad(id:number){
        this.isComunidadSearching = true;

        this.comunidadService.get(id).subscribe(data => {
            this.isComunidadSearching = false;
            if(data != null){
                this.comunidad = data?.Result;
            }
        },(err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    onCancel(){
        this.location.back();
    }

}
